import { NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class WindowService {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.windowSizeSubject = new BehaviorSubject({
            width: window.innerWidth,
            height: window.innerHeight,
        });
        this.windowSize$ = this.windowSizeSubject.asObservable();
        this.listenToResize();
    }
    listenToResize() {
        window.addEventListener('resize', () => {
            this.ngZone.run(() => {
                this.windowSizeSubject.next({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            });
        });
    }
}
WindowService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WindowService_Factory() { return new WindowService(i0.ɵɵinject(i0.NgZone)); }, token: WindowService, providedIn: "root" });
